// extracted by mini-css-extract-plugin
export default {"wrapper":"i8-z","play":"j8-z"};